
const getFormatedPrice = (price) => {
    return price.toFixed(2) + " MAD";
}

export default getFormatedPrice;